import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import Breadcrumb from './Breadcrumb';


export const LocationBar = () => {
	const {	breadcrumb } = useSelector((state) => state);

	const { DesignSystemV3Enabled } = useSelector(
		(state) => state.featureSwitches
	);

	if (breadcrumb) {
		return (
			<div
				className="py-4 px-4 bg-white"
				data-tag-section="lister location bar">
				<div
					className={classNames('mx-auto', {
						'max-w-screen-2xl': DesignSystemV3Enabled,
						'max-w-screen-xl': !DesignSystemV3Enabled,
					})}>
					<div className="flex text-body-xs font-bold">
						<div className="flex-grow pr-2">
							<Breadcrumb breadcrumb={breadcrumb} />
						</div>
					</div>
				</div>
			</div>
		);
	}

	return null;
};

export default LocationBar;
